/* @flow */

export default class UpdateInvestmentProfileInvestProfitRequest {
  investProfit: boolean;
  companyId: number;
  investmentProfileId: number;

  constructor(companyId: number, investmentProfileId: number, investProfit: boolean) {
    this.companyId = companyId;
    this.investmentProfileId = investmentProfileId;
    this.investProfit = investProfit;
  }
}
